var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "visible": "",
      "centered": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": "",
      "modal-class": "iha-withdraw-modal"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.close
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('div', [_c('div', {
    staticClass: "d-flex gap-3"
  }, [_c('div', {
    staticClass: "icon-wrapper d-flex align-items-center justify-content-center "
  }, [_c('i', {
    staticClass: "fas fa-ban"
  })]), _c('div', {
    staticClass: "text-container"
  }, [_c('h5', {
    staticClass: "mb-1 title-text"
  }, [_vm._v("Withdraw Issue ?")]), _c('p', {
    staticClass: "text-contentinfo m-0"
  }, [_vm._v(" This action cannot be undone and is only available before IHA responds. ")])])]), _c('div', {
    staticClass: "d-flex justify-content-end gap-2 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-secondary fs-14",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _c('button', {
    staticClass: "btn btn-danger fs-14",
    on: {
      "click": _vm.withdrawIssue
    }
  }, [_vm._v("Withdraw Issue")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }